import { render, staticRenderFns } from "./client-summary-statistics.vue?vue&type=template&id=1c809ad0&"
import script from "./client-summary-statistics.vue?vue&type=script&lang=js&"
export * from "./client-summary-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports